import { render, staticRenderFns } from "./SignUpConfirm.vue?vue&type=template&id=200b807c&"
import script from "./SignUpConfirm.vue?vue&type=script&lang=js&"
export * from "./SignUpConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports